import type { CoverSelectedParameter } from '../Reports/useCoverSelectedParameters';
import styles from './ReportFlow.module.css';

export type ReportFlowCoverParameter = CoverSelectedParameter;

export const ReportFlowCoverParameters = ({
  parameters,
}: {
  parameters: ReportFlowCoverParameter[];
}) => {
  if (parameters.length === 0) return null;

  return (
    <div
      className={styles.coverParameters}
      data-testid="report-flow-cover-parameters"
    >
      {parameters.map((parameter) => (
        <div
          key={`${parameter.label}:${parameter.value}`}
          className={styles.coverParameterCell}
        >
          <span className={styles.coverParameterLabel}>{parameter.label}</span>
          <span className={styles.coverParameterValue}>{parameter.value}</span>
        </div>
      ))}
    </div>
  );
};
